<template>
  <Select
    :items="finalidades"
    :selectedItem="filter.finalidade"
    label="Finalidade de emissão"
    searchPlaceholder="Buscar finalidade"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        finalidade: {
          id: "",
          name: "",
        },
      },
      finalidades: [
        { id: "nfe_normal", name: "NF-e Normal" },
        { id: "nfe_complementar", name: "NF-e Complementar" },
        { id: "nfe_ajuste", name: "NF-e de Ajuste" },
        { id: "nfe_devolucao", name: "NF-e de Devolução" },
      ],
    };
  },
  methods: {
    atualizar(finalidade) {
      this.filter.finalidade = finalidade;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.finalidade.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.finalidade.id
      });
    },
  },
  mounted() {
    if (!this.filtro?.filtro) {
      console.warn('Propriedade filtro.filtro não encontrada');
      return;
    }
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.finalidades, this.filter.finalidade);
  },
}
</script>
